mutation PayCycleAccountingStamper($input: PayCycleAccountingStamperInput!) {
  payCycleAccountingStamper(input: $input) {
    payCycle {
      id
      _accountingStampDate
      _accountingStampUserId
      _accountingStampUserName
      _accountingStampTransactionReference
    }
  }
}
